export default __webpack_public_path__ + "static/media/1.b2a8df34.webp";